const suffixes: string[] = ['Bytes', 'KB', 'MB', 'GB', 'TB', 'PB']

export const FileSizeToString = (bytes: number): string => {
  let counter: number = 0
  let numberOut: number = bytes
  do {
    numberOut = numberOut / 1024
    counter++
  } while (Math.round(numberOut / 1024) >= 1)
  return `${numberOut.toFixed(1)}${suffixes[counter]}`
}
